import { LoadableLazy } from '@confluence/loadable';

export const ShareAndRestrictDialogController = LoadableLazy<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareAndRestrictDialogController" */ '../src/controller/Controller'
			)
		).Controller,
});
